import React, { StrictMode, FC, useEffect, useState } from 'react'

import PropTypes from 'prop-types'

import CertificateContainer from './CertificateContainer'
import LocalizationProvider from '../../contexts/Localization/LocalizationProvider'


interface InjectedProps {
    locale: string
    translations: any
    certificateFile: string
    certificateFileName: string
    registerDownload: (callback: Function) => void
}
export const App = ({
    locale,
    translations,
    certificateFile,
    certificateFileName,
    registerDownload,
}: InjectedProps) => {
    return (
        <StrictMode>
            <LocalizationProvider locale={locale} translations={translations}>
                <CertificateContainer
                    certificateFile={certificateFile}
                    certificateFileName={certificateFileName}
                    registerDownload={registerDownload}
                />
            </LocalizationProvider>
        </StrictMode>
    )
}

const InjectedAngularPropTypes = PropTypes.shape({
    locale: PropTypes.string,
    translations: PropTypes.object,
    certificateFile: PropTypes.string,
    certificateFileName: PropTypes.string,
    registerDownload: PropTypes.func,
}).isRequired;

App.propTypes = InjectedAngularPropTypes;

export { react2angular } from "../../lib/react2Angular"
